import { ApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { SaveSuccess } from "ui/Scripts/source/models/common/saveSuccess";
import { postApiCall } from "./tokenService";

export const saveChartPanel = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/chartpanel/save", SaveSuccess, JSON.stringify(obj));
};

export const removeChartPanel = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/chartpanel/remove", ApiSuccess, JSON.stringify(obj));
};